<div class="medication-finder-container">
  <platform-page-container
    [contentSpacing]="contentSpacing"
    [fullscreen]="fullscreen"
  >
    <h2 *ngIf="showHeader" class="head mb-4 text-center">
      {{ 'medication_finder_savings_heading' | translate }}
    </h2>
    <zelis-callout-card
      *ngIf="cardText; else loader"
      [ngClass]="{ 'pb-2': contentSpacing }"
      emphasisColor="primary"
      [title]="title | translate: { amount: totalSavings | number: '1.2-2' }"
      [variant]="variant"
    >
      <zelis-button
        variant="flat"
        size="medium"
        color="primary"
        (clickFn)="goToRxSS()"
        >{{ buttonText | translate
        }}<mat-icon
          svgIcon="dls-external-link-light"
          zelisButtonIcon
        ></mat-icon>
      </zelis-button>
      <zelis-callout-card-content>
        {{ cardText | translate }}
      </zelis-callout-card-content>
      <mat-icon [svgIcon]="iconName"></mat-icon>
    </zelis-callout-card>
  </platform-page-container>
</div>

<ng-template #loader>
  <zelis-callout-card>
    <div class="flex gap-3">
      <zelis-skeleton-loader
        class="rounded-full h-24 w-24"
      ></zelis-skeleton-loader>
      <div class="flex flex-col gap-2 flex-grow">
        <zelis-skeleton-loader
          class="dls-heading-3-light"
        ></zelis-skeleton-loader>
        <zelis-skeleton-loader class="text-sm"></zelis-skeleton-loader>
      </div>
      <zelis-skeleton-loader class="text-sm h-10 w-20"></zelis-skeleton-loader>
    </div>
  </zelis-callout-card>
</ng-template>
